<template>
  <div class="product-list">
    <div
      class="product-item"
      v-for="product in $t('hardwarelistone.items')"
      :key="product.id"
      @click="showModal(product)"
    >
      <img :src="product.image" :alt="product.title" />
    </div>

    <!-- 弹出框 -->
    <div v-if="isModalVisible" class="modal">
      <div class="modal-content">
        <span class="productsdectitle">{{ $t("productsdectitle") }}</span>
        <span class="close" @click="hideModal">&times;</span>
        <div class="modal-body">
          <div class="selectedProduct-box">
            <img
              :src="selectedProduct.image"
              class="selectedProduct-img"
              :alt="selectedProduct.title"
            />
          </div>
          <div class="product-title-dec">
            {{ selectedProduct.title }}_{{ selectedProduct.model }}
          </div>
          <div class="model">
            <div class="" v-if="selectedProduct.id === 1">
              <hardwareOne />
            </div>
            <div class="" v-if="selectedProduct.id === 2">
              <hardwareTwo />
            </div>
            <div class="" v-if="selectedProduct.id === 3">
              <hardwareThree />
            </div>
            <div class="" v-if="selectedProduct.id === 4">
              <hardwareFour />
            </div>
            <div class="" v-if="selectedProduct.id === 5">
              <hardwareFive />
            </div>
            <div class="" v-if="selectedProduct.id === 6">
              <hardwareSix />
            </div>
            <div class="" v-if="selectedProduct.id === 7">
              <hardwareSeven />
            </div>
            <div class="" v-if="selectedProduct.id === 8">
              <hardwareEight />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hardwareOne from "./hardwareOne.vue";
import hardwareTwo from "./hardwareTwo.vue";
import hardwareThree from "./hardwareThree.vue";
import hardwareFour from "./hardwareFour.vue";
import hardwareFive from "./hardwareFive.vue";
import hardwareSix from "./hardwareSix.vue";
import hardwareSeven from "./hardwareSeven.vue";
import hardwareEight from "./hardwareEight.vue";
export default {
  components: {
    hardwareOne,
    hardwareTwo,
    hardwareThree,
    hardwareFour,
    hardwareFive,
    hardwareSix,
    hardwareSeven,
    hardwareEight,
  },
  data() {
    return {
      isModalVisible: false,
      selectedProduct: null,
    };
  },
  methods: {
    showModal(product) {
      this.selectedProduct = product;
      this.isModalVisible = true;
    },
    hideModal() {
      this.isModalVisible = false;
    },
  },
};
</script>

<style scoped>
.product-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.product-item {
  width: 47%;
  margin: 10px 1%;
  text-align: center;
  cursor: pointer;
}
.product-item img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}
.product-title {
  margin-top: 10px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 70%;
  position: relative;
  border-radius: 5px;
}

.selectedProduct-box {
  width: 100%;
  text-align: center;
}
.selectedProduct-img {
  width: 50%;
  margin-bottom: 20px;
}
.product-title-dec {
  background: #d1261e;
  color: #fff;
  padding: 10px 20px;
  box-sizing: border-box;
  text-align: center;
}

.close {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 40px;
  cursor: pointer;
}
.model {
  border: 1px solid #ddd;
  padding: 10px 20px;
  box-sizing: border-box;
}
.model-li {
  padding: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
}

.modal-body {
  margin-top: 20px;
  height: 700px;
  overflow-y: auto;
}

@media (max-width: 1200px) {
  .modal-content {
    width: 80%;
  }
  .selectedProduct-img {
    width: 100%;
  }
  .product-item {
    width: 47%;
    margin: 10px 1%;
  }
  .modal-body {
    height: 500px;
  }
}
</style>